<template>
  <section class="login-page">
    <div class="login-page__card white rounded-xl elevation-6">
      <div class="mb-4">
        <icon-logo class="logo"></icon-logo>
      </div>
      <div class="mb-6">
        <h1 class="text-h6 primary--text text-center font-weight-black">
          INICIO DE SESIÓN
        </h1>
      </div>

      <v-form v-model="valid" @submit.prevent="login()">
        <div>
          <p class="text-subtitle-2 font-weight-regular mb-2">Usuario</p>
          <v-text-field
            v-model="user.username"
            class="rounded-lg"
            dense
            height="46"
            placeholder="Ingrese su usuario"
            @input="error = null"
            outlined
            :rules="[rules.required]"
          ></v-text-field>
        </div>
        <div>
          <p class="text-subtitle-2 font-weight-regular mb-2">Contraseña</p>
          <v-text-field
            v-model="user.password"
            class="rounded-lg"
            dense
            height="46"
            placeholder="Ingrese su contraseña"
            @input="error = null"
            type="password"
            outlined
            :rules="[rules.required]"
          ></v-text-field>
        </div>
        <v-alert v-if="error" type="error" dense class="mb-4">{{ error }}</v-alert>
        <div class="d-flex justify-center mt-2">
          <v-btn
            :disabled="!valid"
            :loading="isLoading"
            class="font-weight-regular"
            type="submit"
            large
            block
            depressed
            color="primary"
            >INICIAR SESION</v-btn
          >
        </div>
      </v-form>
    </div>
  </section>
</template>

<script>
// Domain
import Auth from "../domain/Auth";

export default {
  components: {
    IconLogo: () => import("../components/icons/IconLogo")
  },
  data: () => ({
    valid: false,
    error: null,
    user: {
      username: process.env.VUE_APP_USERNAME,
      password: process.env.VUE_APP_PASSWORD
    },
    rules: {
      required: val => !!val || "Este campo es requerido",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Correo electrónico.";
      }
    },
    isLoading: false
  }),
  methods: {
    async login() {
      this.isLoading = true;
      this.error = null;
      try {
        await Auth.login(this.$store, this.user);
        this.$router.push("/");
      } catch ({ data }) {
        this.error = data.error;
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  background-color: #f4f5f7;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;

  &__card {
    width: 100%;
    max-width: 400px;
    padding: 40px 32px 36px;
  }
}

.logo {
  max-width: 14rem;
  margin: 0 auto;
  display: block;
}

@media (max-width: 400px) {
  .login-page__card {
    padding: 32px 20px 28px;
  }
}
</style>
